import { render, staticRenderFns } from "./GameRondoEn.vue?vue&type=template&id=25a6af52&scoped=true&"
import script from "./GameRondoEn.vue?vue&type=script&lang=js&"
export * from "./GameRondoEn.vue?vue&type=script&lang=js&"
import style0 from "./GameRondoEn.vue?vue&type=style&index=0&id=25a6af52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6af52",
  null
  
)

export default component.exports